<template>
    <v-dialog v-model="dialog" max-width="900px">
        <v-card style="min-height: 530px;">
            <v-card-title>
                <h3>{{ title }} </h3>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" v-if="connectionError==null" append-icon="search" label="Ara..." single-line hide-details style="padding-right: 1em;max-width: 220px"></v-text-field>
            </v-card-title>
            <v-card-subtitle><span v-if="connectionError==null"> Toplam : <b>{{ total }}</b> kişi kayıtlı.</span></v-card-subtitle>
            <v-data-table dense :headers="header" :items="data" :search="search" :itemsPerPage="15" v-if="connectionError==null || data.length>0">
                <template slot="items" slot-scope="props">
                    <tr v-if="!isMobile">
                        <td>{{ props.item.firstname }}</td>
                        <td class="text-xs-left">{{ props.item.lastname }}</td>
                        <td class="text-xs-left">{{ props.item.identify }}</td>
                        <td class="text-xs-left">{{ props.item.country }}</td>
                        <td class="text-xs-left">{{ props.item.room }}</td>
                    </tr>
                </template>
            </v-data-table>
            <div style="padding: 1em" v-else v-html="connectionError"></div>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "registeredUsers",
        data(){
            return {
                search:'',
                header: [
                    {
                        text: 'Isim',
                        align: 'left',
                        value: 'Name'
                    },
                    {
                        text: 'Soyisim',
                        value: 'Surname'
                    },
                    {
                        text: 'Kimlikno',
                        value: 'IdCard_No'
                    },
                    {
                        text: 'Oda',
                        value: 'Room_No'
                    },
                    {
                        text: 'Kayıt Tarihi',
                        value: 'RegisterDate'
                    },
                ],
            }
        },
        computed: {
            dialog:{
                get(){
                    return this.$store.state.registeredUsers.dialog
                },
                set(){
                    this.$store.commit("registeredUsers/ShowDialog",!this.dialog)
                }
            },
            total(){
                return this.$store.state.registeredUsers.total
            },
            title(){
                return this.$store.state.registeredUsers.title
            },
            data(){
                return this.$store.state.registeredUsers.data
            },
            connectionError(){
                return this.$store.state.registeredUsers.connectionError
            },

        },
    }
</script>

<style scoped>
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
        font-size: 0.8rem;
        font-weight: 400;
    }
    .v-data-table--dense > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > td, .v-data-table--dense > .v-data-table__wrapper > table > tfoot > tr > td {
        height: 22px;
        padding: 1px 12px;
    }
</style>